/* stylelint-disable order/properties-order */
<template lang="pug">
#schedule-training
	.split-container
		.events-list
			PendingRequests
		.calendar-container
			Calendar(
				v-model:selected-date="selectedDate"
				:event-list="userEvents"
				:sort-category="sort"
				:display="display"
			)
				template(#header-left)
					.selectors
						.option
							label View
							select(v-model="display")
								option(value="month") Month
								option(value="week") Week
								option(value="day") Day
						.option
							label Sort by
							select(v-model="sort")
								option(value="time") Time
								option(value="trainer") Trainer
								option(value="kennel") Kennel
				template(#header-right)
					.header-buttons
						button.bottom-button(
							@click="openManageCalendarModal()"
						) Manage Calendars
	template(v-if="selectedEvent")
		Teleport(to="body")
		EventModal(
			:selected-event="selectedEvent"
			@close="selectedEvent=null"
		)

	Modal(v-if="showCalendarModal"  @close="showCalendarModal = false")
		ManageCalendarsModal
	//- Teleport(to="#schedule-training")
	//- Alert(:main-calendar="calendarStore.main")
	//- Alert(v-if="!mainCalendarId" :main-calendar="calendarStore.main")
	Alert(v-if="showAlert" :main-calendar="calendarStore.main")
</template>
<script lang="ts" setup>
import { ref, computed, watch } from "vue";
import { CalendarEvents, Events } from '@busy-human/k9-library';
import { DataInstance } from "@busy-human/gearbox";
import { useCalendars } from "@/store/useCalendars";
import Calendar from '@/components/linear-calendar.vue';
import EventModal from '@/components/event-modal.vue';
import Modal from '@/components/Modal.vue';
import PendingRequests from "@/components/pending-requests.vue";
import ManageCalendarsModal from "@/components/scheduling/manage-calendars-modal.vue";
import Alert from "@/components/alerts.vue";

const calendarStore = useCalendars();
const selectedEvent = ref<DataInstance<CalendarEvents.Model> | null>(null);

const userEvents = computed(() => {
	const tmp: DataInstance<Events.Model>[] = [];
	for(const [, cal] of calendarStore.events) {
		for(const evs of Object.values(cal)) {
			tmp.push(...evs);
		}
	}
	return tmp;
});

const showAlert = computed(()=>{

    if( !calendarStore.loading && calendarStore.main?.calendarId === undefined){
        return true;
    } else {
        return false;
    }

});
// })

const display = ref<'month' | 'week' | 'day'>('week');
const sort = ref<'trainer' | 'kennel' | 'time'>('trainer');
const selectedDate = ref<Date>(new Date());

// Calendar Management

const showCalendarModal = ref(false);
const selectedCalendar = ref<string | null>(null);
const userSelectedCalendar = ref<boolean>(false);

watch(selectedCalendar, (cal) => {
	if(cal) {
		userSelectedCalendar.value = true;
	}
});

function openManageCalendarModal() {
	showCalendarModal.value = true;
}
</script>
<style lang="scss">
#schedule-training {
	width: clamp(10rem, 100%, calc(100% - 12.5rem));
	height: 100%;
	margin: auto;
	overflow: hidden;
	background-color: $color-white;

	.split-container{
		display: flex;
		gap: 1rem;
		justify-content: space-between;
		justify-content: center;
		height: calc(100% - 5rem);
		padding: 1rem 0;

		.calendar-container{
			width: 100%;
			max-width: calc(100% - 2rem);
			height: 100%;
			max-height: calc(100vh - 6rem);
		}
	}

	.calendar-container .selectors {
		display: flex;
		flex-wrap: wrap;
		gap: 1em;
		height: 100%;

		.option {
			flex-shrink: 0;
		}

		label {
			box-sizing: border-box;
			height: .1em;
			font-size: .75em;
			font-weight: 100;
			line-height: 100%;
			color: $color-gray-62;
			vertical-align: bottom;
		}

		select {
			width: 100%;
			padding: .5em .25em;
			border-radius: 0;
		}
	}

	.bottom-button {
		display: flex;
		align-items: center;
		margin-top: auto;

		svg {
			width: 18px;
			padding-left: .5rem;
		}
	}

	.manage {padding: .5rem 1rem;}

	.header-buttons {
		display: flex;
		flex-direction: row;
		height: 100%;
	}
}
</style>